import React, { useState, useContext } from "react";
import "./Signup.css";
import { MyContext } from "../../../../Context/MyContext";
import API from "../../../../Api/api";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { toast } from "react-toastify";
import OtpModal from "./OtpModal";
import CaptchaField from "../../../../Components/CaptchaField";
import AppIcon from "../../../../Components/AppIcon";

const Signup = ({ setActiveTab }) => {
  const { logininput } = useContext(MyContext);
  const safeSignup = logininput?.signup || [];

  const [formData, setFormData] = useState({ name:"", phone:"", email:"", password:"", confirm_password:"" });
  const [showPassword,  setShowPassword]  = useState(false);
  const [showCPassword, setShowCPassword] = useState(false);
  const [otpModal, setOtpModal] = useState(false);
  const [otpType,  setOtpType]  = useState("");
  const [otpPin,   setOtpPin]   = useState("");  // dev mode only
  const [sending,  setSending]  = useState(false);
  const [loading,  setLoading]  = useState(false);
  const [verified, setVerified] = useState({ phone: false, email: false });
  const [captcha, setCaptcha] = useState({ captcha_id: '', captcha_answer: '' });
  const [captchaValid, setCaptchaValid] = useState(true);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (e.target.name === "phone") setVerified(p => ({ ...p, phone: false }));
    if (e.target.name === "email") setVerified(p => ({ ...p, email: false }));
  };

  const sendOtp = async (type) => {
    if (type === "phone" && !formData.phone) { toast.error("Enter phone first!"); return; }
    if (type === "email" && !formData.email) { toast.error("Enter email first!"); return; }

    setSending(true);
    try {
      if (type === "email") {
        const res = await API.post('/auth/send-otp', { email: formData.email, purpose: 'signup' });
        // Dev mode
        if (res.data.otp_dev) {
          setOtpPin(res.data.otp_dev);
          toast.info(`Dev OTP: ${res.data.otp_dev}`);
        } else {
          setOtpPin("");  // real OTP — backend verify பண்ணும்
          toast.success(`OTP sent to ${formData.email}`);
        }
      } else {
        // Phone — demo
        setOtpPin("123456");
        toast.success("Demo OTP: 123456");
      }
      setOtpType(type);
      setOtpModal(true);
    } catch (err) {
      toast.error(err.response?.data?.error || "Failed to send OTP");
    } finally { setSending(false); }
  };

  const validateFields = () => {
    const fields = safeSignup.filter(i => i.field !== "otp");
    for (let item of fields) {
      if (item.isrequired && !formData[item.field]) { toast.error(`${item.name} is required!`); return false; }
    }
    for (let field of fields.filter(i => i.otp_show)) {
      if (!verified[field.field]) { toast.error(`Please verify your ${field.name}!`); return false; }
    }
    if (formData.password !== formData.confirm_password) { toast.error("Passwords must match!"); return false; }
    if (!captchaValid) { toast.error("Please complete the CAPTCHA verification"); return false; }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateFields()) return;
    setLoading(true);
    try {
      await API.post('/auth/signup', {
        user_name:  formData.name,
        email:      formData.email,
        user_phone: formData.phone,
        password:   formData.password,
        captcha_id: captcha.captcha_id,
        captcha_answer: captcha.captcha_answer,
      });
      toast.success("Signup Successful! Please login.");
      setActiveTab("login");
    } catch (err) {
      toast.error(err.response?.data?.error || "Signup failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="signup-container">
      <form className="signup-form" onSubmit={handleSubmit}>
        {safeSignup.filter(i => i.field !== "otp").map(item => (
          <div key={item.id} className="input-group">
            <label>{item.name}</label>
            <div className="input-wrapper">
              <input
                type={item.type === "password"
                  ? (item.field === "confirm_password" ? (showCPassword?"text":"password") : (showPassword?"text":"password"))
                  : item.type}
                name={item.field} value={formData[item.field] || ""}
                onChange={handleChange} placeholder={item.name}/>
              {item.otp_show && (
                verified[item.field]
                  ? <span className="verified-badge">Verified <AppIcon name="check" size={12} /></span>
                  : <button type="button" className="verify-btn" disabled={sending}
                      onClick={() => sendOtp(item.field)}>
                      {sending ? "…" : "Verify"}
                    </button>
              )}
              {item.type === "password" && item.is_show && item.field !== "confirm_password" && (
                <span className="eye-icon" onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <FaEyeSlash/> : <FaEye/>}
                </span>
              )}
              {item.type === "password" && item.is_show && item.field === "confirm_password" && (
                <span className="eye-icon" onClick={() => setShowCPassword(!showCPassword)}>
                  {showCPassword ? <FaEyeSlash/> : <FaEye/>}
                </span>
              )}
            </div>
          </div>
        ))}
        <CaptchaField
          value={captcha.captcha_answer}
          onChange={setCaptcha}
          onValidChange={setCaptchaValid}
        />
        <button type="submit" className="signup-btn" disabled={loading || !captchaValid}>
          {loading ? "Signing up…" : "Signup"}
        </button>
        <p className="login-text">Already have an account? <span onClick={() => setActiveTab("login")}>Login</span></p>
      </form>

      {/* ✅ email prop pass பண்றோம் — OtpModal backend verify பண்ணும் */}
      <OtpModal
        otpModal={otpModal}
        setOtpModal={setOtpModal}
        otpType={otpType}
        otpPin={otpPin}
        setVerified={setVerified}
        email={otpType === "email" ? formData.email : formData.phone}
        onResend={() => sendOtp(otpType)}
      />
    </div>
  );
};

export default Signup;